import React from 'react';
import * as PropTypes from 'prop-types';
import OnClickOutside from 'Components/common/OnClickOutside/OnClickOutside';
import classNames from 'classnames';

const ExplorerModal = props => {
    return (
        <div className={classNames('modal-wrapper-container', props.wrapperClass)}>
            <OnClickOutside onClickOutside={props.onClose}>
                <div className="modal-wrapper">
                    <div className="modal-text-wrapper">
                        {props.titleImage}
                        <div>
                            <p className="modal-title">
                                {props.title.map(titleItem => (
                                    <span key={`${titleItem}`}>{titleItem}</span>
                                ))}
                            </p>

                            <p className="modal-underscore" />
                            <p className="modal-sub-title animate-fade-in">{props.subTitle}</p>
                        </div>
                    </div>
                    <div className="modal-button-wrapper animate-fade-in">{props.buttons}</div>
                </div>
            </OnClickOutside>
        </div>
    );
};

ExplorerModal.propTypes = {
    titleImage: PropTypes.object,
    title: PropTypes.array,
    subTitle: PropTypes.string,
    buttons: PropTypes.object,
    wrapperClass: PropTypes.string,
    onClose: PropTypes.func.isRequired,
};

export default ExplorerModal;
